// extracted by mini-css-extract-plugin
module.exports = {"button":"Styles_button__2rQjl","buttonNormal":"Styles_buttonNormal__3N2QQ","bgPartial":"Styles_bgPartial__3Q7NL"};